import { SHStack, SHTypography } from "@components/design-systems";
import { AnalysisDecisionStatus } from "@models/platform-analysis/enums/feature/decisionStatus";
import { getProductDecisionBannerConfigs } from "../../utils";

type AnalysisTableDecisionBannerProps = {
  decisionStatus?: AnalysisDecisionStatus | null;
  isMissingEssential?: boolean;
  isPseudoElement?: boolean;
};

export const AnalysisTableDecisionBanner = ({
  decisionStatus,
  isMissingEssential,
  isPseudoElement = false,
}: AnalysisTableDecisionBannerProps) => {
  const configs = getProductDecisionBannerConfigs({
    decisionStatus,
    isMissingEssential,
  });

  if (!configs) return <SHStack className="DecisionBanner" />;

  return (
    <SHStack className="DecisionBanner" bgcolor={configs.bgColor}>
      <SHStack
        className={`DecisionBanner-content ${isPseudoElement ? "pseudo" : ""}`}
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        {configs.startIcon}
        <SHTypography
          variant="body3"
          colorVariant="white"
          paddingBottom="-2px"
          fontSize="12px"
        >
          {configs.title}
        </SHTypography>
      </SHStack>
    </SHStack>
  );
};
